module.exports = __webpack_public_path__ + "static/media/bg-fonze.5fc8550c.jpg";